import { useState, type FormEvent } from 'react';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button, Field } from '../../shared/ui/components';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Solicitar Membresía con el código de la Iglesia.
 * Provisional: la forma definitiva (invitación, enlace o QR) está pendiente de decisión (IDR-008).
 */
export function JoinChurchForm({ onSent }: { onSent?: () => void } = {}) {
  const [message, setMessage] = useState<{ tone: 'error' | 'success'; text: string } | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const formEl = event.currentTarget;
    const code = String(new FormData(formEl).get('code')).trim();
    if (!UUID.test(code)) {
      setMessage({ tone: 'error', text: 'El código no tiene el formato correcto.' });
      return;
    }
    setBusy(true);
    setMessage(null);
    try {
      await api.post(`/multichurch/churches/${code}/membership-requests`);
      setMessage({ tone: 'success', text: 'Solicitud enviada. Queda pendiente de aprobación de la iglesia; te avisaremos cuando te acepten.' });
      formEl.reset();
      onSent?.();
    } catch (e) {
      setMessage({ tone: 'error', text: errorMessage(e) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="form form--inline" onSubmit={onSubmit} noValidate>
      {message ? <Alert tone={message.tone}>{message.text}</Alert> : null}
      <Field label="Código de la iglesia" name="code" autoComplete="off" spellCheck={false} required />
      <Button type="submit" variant="secondary" busy={busy}>
        Solicitar unirme
      </Button>
    </form>
  );
}
